import { useApp } from 'context/app-context'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Modal } from 'ui'

const AppContextModal = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const { pathname } = useRouter()
  const { modal, setModal, modalProps, resetModalProps } = useApp()

  useEffect(() => {
    setModal(null)
  }, [pathname, setModal])

  useEffect(() => {
    setVisible(modal !== null)

    return () => {
      setVisible(false)
    }
  }, [modal])

  return (
    <Modal
      open={visible}
      onClose={() => {
        setVisible(false)
        setModal(null)
        resetModalProps()
      }}
      {...modalProps}>
      {modal}
    </Modal>
  )
}

export default AppContextModal
